import { render, staticRenderFns } from "./DashboardV1.vue?vue&type=template&id=9da16b3e&scoped=true"
import script from "./DashboardV1.vue?vue&type=script&lang=js"
export * from "./DashboardV1.vue?vue&type=script&lang=js"
import style0 from "./DashboardV1.vue?vue&type=style&index=0&id=9da16b3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da16b3e",
  null
  
)

export default component.exports